import React from 'react'
import { clientOneData } from '../data'

import TinySlider from "tiny-slider-react";
import 'tiny-slider/dist/tiny-slider.css';

export default function ClientOne({textLight}) {

    const settings = {
        container: '.tiny-single-item',
        items: 1,
        controls: false,
        mouseDrag: true,
        loop: true,
        rewind: true,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        navPosition: "bottom",
        speed: 400,
        gutter: 16,
      };

  return (
    <>
    <div className="tiny-single-item">
        <TinySlider settings={settings}>
            {clientOneData.map((item,index)=>{
            return(
                    <div className="tiny-slide" key={index}>
                        <div className="single-review">
                            <ul className="list-unstyled h5 text-warning">
                                <li className="list-inline-item"><i className="mdi mdi-star fs-6"></i></li>
                                <li className="list-inline-item"><i className="mdi mdi-star fs-6"></i></li>
                                <li className="list-inline-item"><i className="mdi mdi-star fs-6"></i></li>
                                <li className="list-inline-item"><i className="mdi mdi-star fs-6"></i></li>
                                <li className="list-inline-item"><i className="mdi mdi-star fs-6"></i></li>
                            </ul>
                            <p className={`h5 review fst-italic fw-normal ${textLight ? 'text-white title-dark' : 'text-muted'}`}>{item.desc}</p>
                            <div className="reviewer mt-3">
                                <img src={item.image} className="img-fluid avatar avatar-ex-sm rounded-pill mx-auto shadow" alt=""/>
                                <h6 className={`mb-0 mt-2 ${textLight ? 'text-white title-dark' : ''}`}>{item.name}</h6>
                                <p className={`mb-0 ${textLight ? 'text-white title-dark' : ''}`}>{item.title}</p>
                            </div>
                        </div>
                    </div>
            )
            })} 
        </TinySlider>
        
    </div>
    </>
  )
}
